module.exports = __webpack_public_path__ + "img/orange_129.817e02b9.png";